import React, { Component, useState } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Nav from 'react-bootstrap/Nav';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import Dropdown from 'react-bootstrap/Dropdown';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { FaExternalLinkAlt, FaAndroid, FaApple } from 'react-icons/fa';
import AppsDrawer from '@appblocks/frontend/client/Components/AppsDrawer';
import LoginButton from '@appblocks/frontend/client/Components/LoginButton';
import Header from '@appblocks/frontend/client/Header';
import PasswordChange from '@appblocks/frontend/client/Components/PasswordChange';
import EditableLabel from '@appblocks/frontend/client/Components/EditableLabel';


const mapStateToProps = state => state;

class PageAccount extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user: {
                firstName: '',
                lastName: '',
            },
            success: false,
        };

        this.save = this.save.bind(this);
    }

    componentDidMount() {
        if (!this.props.user.user) {
            this.props.history.push('/login');
        }
        this.getProfileInformation();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.success === false && this.state.success === true) {
            setTimeout(() => {
                this.setState({
                    success: false,
                });
            }, 5000);
        }
    }


    async getProfileInformation() {
        try {
            const response = await axios.get(`${process.env.API_URL}/api/account/profile`, {
                withCredentials: true,
            });
            const { firstName, lastName } = response.data;
            this.setState({
                user: {
                    firstName,
                    lastName,
                },
            });
        } catch (e) {
            console.error(e);
        }
    }

    save(field, fieldValue) {
        axios.post(`${process.env.API_URL}/api/account/updateprofile`, {
            [field]: fieldValue,
        }, {
            withCredentials: true,
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    const { user } = this.state;
                    this.setState({
                        success: true,
                        user: {
                            ...user,
                            [field]: fieldValue,
                        },
                    });
                }
            })
            .catch((e) => {

            });
    }

    render() {
        const { user } = this.props.user;
        return (
            <>
                <div className="col-6 mb-4">
                    <div className="row">
                        <h3>User information</h3>
                    </div>
                    <div className="row mb-1">
                        <div className="col-12 mb-4">
                            <label className="form-label" htmlFor="email">Email</label>
                            <input
                                type="text"
                                className="form-control"
                                id="email"
                                placeholder={user.email}
                                value={user.email || ''}
                                disabled
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label" htmlFor="firstName">First Name</label>
                            <EditableLabel
                                onSave={newName => this.save('firstName', newName)}
                                text={this.state.user.firstName}
                                asProps={{
                                    type: 'text',
                                    value: this.state.user.firstName,
                                    readOnly: true,
                                }}
                            >
                                <div className="form-control-plaintext">
                                    {this.state.user.firstName || 'First Name'}
                                </div>
                            </EditableLabel>
                        </div>
                        <div className="col-md-6">
                            <label className="form-label" htmlFor="lastName">Last Name</label>
                            <EditableLabel
                                onSave={newName => this.save('lastName', newName)}
                                text={this.state.user.lastName}
                                asProps={{
                                    type: 'text',
                                    value: this.state.user.lastName,
                                    readOnly: true,
                                }}
                            >
                                <div className="form-control-plaintext">
                                    {this.state.user.lastName || 'Last Name'}
                                </div>
                            </EditableLabel>
                        </div>
                        <div className="col-md-12 mt-2">
                            {
                                this.state.success && (
                                    <div className="alert alert-success">
                                        User information updated
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    <hr />
                    <div className="row">
                        {
                            user.thirdParty === undefined && (
                                <div className="col-md-12">
                                    <PasswordChange />
                                </div>
                            )
                        }
                    </div>
                </div>
            </>
        );
    }
}

export default connect(mapStateToProps, {})(
    Object.assign(withRouter(PageAccount), { contextType: undefined }),
);
